import { Injectable } from '@angular/core';
import { FilterAssistQuery } from '../../../interfaces/filter-assist-query';
import { ContactsQuery } from '../../../models/contacts-query';
import { ContactFilterService } from '../services/contact-filter.service';
import { AddressBookService } from '../../../data/address-book.service';
import { Observable, of } from 'rxjs';
import { FilterAssist } from '../../../models/filter-assist';
import { map, startWith } from 'rxjs/operators';
import { FilterCategoryEnum } from '../../../enum/filter-category.enum';

@Injectable({
    providedIn: 'root'
})
export class ContactAddressBookFilterService implements FilterAssistQuery<ContactsQuery> {

    private CONTACT_ADDRESS_BOOK = 'CONTACT_ADDRESS_BOOK';

    constructor(private contactFilterService: ContactFilterService, private addressBookService: AddressBookService) {
        this.contactFilterService.registerFilters(this);
    }

    active(query: ContactsQuery): Observable<FilterAssist[]> {
        if (query.addressBookId) {
            return this.addressBookService.get(query.addressBookId).pipe(
                map((addressBook) => ([{
                    id: this.CONTACT_ADDRESS_BOOK,
                    description: addressBook.name,
                    category: FilterCategoryEnum.ADDRESS_BOOK,
                    score: 0,
                    parameter: query.addressBookId
                }]))
            );
        } else {
            return of([]);
        }
    }

    apply(id: string, parameter: any, query: ContactsQuery): void {
        switch (id) {
            case this.CONTACT_ADDRESS_BOOK:
                query.addressBookId = parameter;
                break;
        }
    }

    ids(): string[] {
        return [ this.CONTACT_ADDRESS_BOOK ];
    }

    match(terms: string): Observable<FilterAssist[]> {
        if (terms.length < 2) {
            return of([]);
        }
        return this.addressBookService.getAll().pipe(
            startWith([]),
            map((addressBooks) => addressBooks
                .filter((a) => a.name.toLowerCase().indexOf(terms.toLowerCase()) > -1)),
            map((addressBooks) => addressBooks.map((a) => ({
                id: this.CONTACT_ADDRESS_BOOK,
                    parameter: a.id,
                description: a.name,
                category: FilterCategoryEnum.ADDRESS_BOOK,
                score: 10
            })))
        );
    }

    unapply(id: string, query: ContactsQuery): void {
        switch (id) {
            case this.CONTACT_ADDRESS_BOOK:
                query.addressBookId = null;
                break;
        }
    }
}
